export const SET_CORRELATIONS = 'SET_CORRELATIONS';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_IS_LOADING_ASSIGN_GENERICS = 'SET_IS_LOADING_ASSIGN_GENERICS';
